import gql from 'graphql-tag';

export const RENAME_FILE = gql`
  mutation RenameFile($renameFilePassword: String!, $fileId: String!, $name: String!) {
    accounting {
      renameFile(password: $renameFilePassword, fileId: $fileId, name: $name)
    }
  }
`;

export const DELETE_FILE = gql`
  mutation DeleteCompanyFile($fileId: String!) {
    accounting {
      deleteCompanyFile(fileId: $fileId)
    }
  }
`;

export const MOVE_FILE = gql`
  mutation MoveFile($moveFilePassword: String!, $folderId: String!, $moveFileId: String!) {
    accounting {
      moveFile(password: $moveFilePassword, folderId: $folderId, fileId: $moveFileId)
    }
  }
`;

export const MOVE_CONTRACT = gql`
  mutation moveContract($contractId: String!, $periodsSubfolderId: String!) {
    accounting {
      moveContract(contractId: $contractId, periodsSubfolderId: $periodsSubfolderId) {
        id
        name
        periodsSubfolderId
      }
    }
  }
`;

export const DOWNLOAD_ARCHIVE = gql`
  mutation archive($fileIds: [String!]!) {
    archive(fileIds: $fileIds)
  }
`;

export const DELETE_CONTRACT_FILE = gql`
  mutation DeleteContract($contractId: String!) {
    accounting {
      deleteContract(contractId: $contractId)
    }
  }
`;

export const SAVE_FILES_SUBFODLER = gql`
  mutation SaveFilesInSubfolderId($companyId: UuidType!, $files: [FileInSubfolderIdInput]!) {
    accounting {
      saveFilesInSubfolderId(companyId: $companyId, files: $files) {
        id
        companyId
        name
        type
        status
        source
        moniteInvoice {
          id
        }
      }
    }
  }
`;

export const SAVE_FILES_IN_CONTRACTS = gql`
  mutation SaveFilesInContractsFolder(
    $companyId: UuidType!
    $files: [FileInContractsFolderInput]!
  ) {
    accounting {
      saveFilesInContractsFolder(companyId: $companyId, files: $files) {
        companyId
        id
        name
        contractsFolderId
      }
    }
  }
`;

export const EDIT_FILE_IS_READ = gql`
  mutation editFileIsRead($fileId: String!, $isRead: Boolean!) {
    accounting {
      editFileIsRead(fileId: $fileId, isRead: $isRead)
    }
  }
`;

export const CHANGE_FILES_STATUS = gql`
  mutation changeFilesStatus($fileIds: [String!]!, $accStatusId: FileAccStatus!, $rejectionReasonId: FileRejectionReason, $rejectionComment: String) {
    accounting {
      changeFilesStatus(fileIds: $fileIds, accStatusId: $accStatusId, rejectionReasonId: $rejectionReasonId, rejectionComment: $rejectionComment)
    }
  }
`;

export const COPY_REPORT_FILES_TO_PREVIOUS_YEAR = gql`
  mutation copyReportFilesToPreviousYear($sourcePeriodFolderId: UuidType!) {
    accounting {
      copyReportFilesToPreviousYear(sourcePeriodFolderId: $sourcePeriodFolderId)
    }
  }
`;
